function dropdowntoggle(header) {
    var panel = header.nextElementSibling;

    var plusicon = header.querySelector(".otsikko .icon-plus");
    var minusicon = header.querySelector(".otsikko .icon-minus");


    if (!panel.classList.contains("active")) {

        header.setAttribute("aria-expanded", "true");
        plusicon.classList.remove("show");
        plusicon.classList.add("hidden");
        minusicon.classList.remove("hidden");
        minusicon.classList.add("show");

        panel.classList.add("active");
        panel.style.height = "auto";

        var height = panel.clientHeight + "px";

        panel.style.height = "0px";

        setTimeout(function () {
            panel.style.height = height;
        }, 0);

    } else {

        header.setAttribute("aria-expanded", "false");
        plusicon.classList.remove("hidden");
        plusicon.classList.add("show");
        minusicon.classList.remove("show");
        minusicon.classList.add("hidden");

        panel.style.height = "0px";

        panel.addEventListener("transitionend", function () {
            panel.classList.remove("active");
        }, {
        once: true
        });

    }
}


var dropdown = document.getElementsByClassName("dropdown__header");
var i;

for (i = 0; i < dropdown.length; i++) {
    dropdown[i].addEventListener("click", function() {
        dropdowntoggle(this);
    });
    dropdown[i].addEventListener("keyup", function(e) {
        e.preventDefault();
        if ( e.keyCode === 13 || e.keyCode === 32 ) { //enter, space
            dropdowntoggle(this);
        }
    });

}

jQuery(document).on("sf:ajaxfinish", ".searchandfilter", function(){
    for (i = 0; i < dropdown.length; i++) {
        dropdown[i].addEventListener("click", function() {
            dropdowntoggle(this);
        });
        dropdown[i].addEventListener("keyup", function(e) {
            e.preventDefault();
            if ( e.keyCode === 13 || e.keyCode === 32 ) { //enter, space
                dropdowntoggle(this);
            }
        });

    }
});
